import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Fab from '@mui/material/Fab';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import NavigationIcon from '@mui/icons-material/Navigation';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import Switch from '@mui/material/Switch';
import Paper from '@mui/material/Paper';
import Grow from '@mui/material/Grow';
import Fade from '@mui/material/Fade';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import SlideshowOutlinedIcon from '@mui/icons-material/SlideshowOutlined';
import DraftsOutlinedIcon from '@mui/icons-material/DraftsOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import FontDownloadOutlinedIcon from '@mui/icons-material/FontDownloadOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import { SOLUTIONS_ROOT_URL } from '../config/solutionsArticles';

const PREFIX = 'GetSupport';
const classes = {
  root: `${PREFIX}-root`,
  wrapper: `${PREFIX}-wrapper`,
  container: `${PREFIX}-container`,
  margin: `${PREFIX}-margin`,
  leftIcon: `${PREFIX}-leftIcon`,
  rightIcon: `${PREFIX}-rightIcon`,
  toggleBtn: `${PREFIX}-toggleBtn`,
  subBtn: `${PREFIX}-subBtn`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    position: 'fixed',
    zIndex: 1000,
    bottom: 12,
    right: 24,
  },
  [`& .${classes.wrapper}`]: {
    position: 'relative',
  },
  [`& .${classes.container}`]: {
    position: 'absolute',
    bottom: 60,
    right: 0,
    width: 'auto',
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
      textAlign: 'right',
    }
  },
  [`& .${classes.margin}`]: {
    margin: theme.spacing(1),
  },
  [`& .${classes.leftIcon}`]: {
    marginRight: theme.spacing(1),
  },
  [`& .${classes.rightIcon}`]: {
    marginLeft: theme.spacing(1),
  },
  [`& .${classes.toggleBtn}`]: {
    opacity: .75,
  },
  [`& .${classes.subBtn}`]: {
    margin: '8px 0',
    whiteSpace: 'nowrap',
    boxShadow: '0px 15px 25px -3px rgba(155,155,155,.75),0px 8px 100px 1px rgba(255,255,255,0.9),0px 3px 14px 2px rgba(255,255,255,0.12)',
    '&.light': {
      backgroundColor: '#ffffff',
    }
  },
}));

class GetSupport extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      checked: false,
    };
  }

  handleContactSupport = () => {
    window.FreshWidget.show();
  };

  handleStartTour = () => {
    this.props.onStartTour();
  };

  handleOpen = () => {
    this.setState(state => ({ checked: true }));
  };
  handleClose = () => {
    this.setState(state => ({ checked: false }));
  };

  render() {
    const { checked } = this.state;

    return (
      <Root className={classes.root} onMouseEnter={this.handleOpen} onMouseLeave={this.handleClose}>
        <div className={classes.wrapper}>
          <div className={classes.container}>
            {this.props.onStartTour &&
              <Grow in={checked} unmountOnExit={true} {...(checked ? { timeout: 1500 } : {})}>
                <div>
                  <Button
                    variant="outlined"
                    size="medium"
                    className={classNames(classes.subBtn, 'light')}
                    onClick={this.handleStartTour}>
                    Starter Tour
                    <FontDownloadOutlinedIcon className={classes.rightIcon} />
                  </Button>
                </div>
              </Grow>
            }
            <Grow in={checked} unmountOnExit={true} {...(checked ? { timeout: 1000 } : {})}>
              <div>
                <Button
                  variant="outlined"
                  size="medium"
                  className={classNames(classes.subBtn, 'light')}
                  href={SOLUTIONS_ROOT_URL}
                  target="_blank"
                  rel="noopener noreferrer">
                  Documentation
                  <OpenInNewOutlinedIcon className={classes.rightIcon} />
                </Button>
              </div>
            </Grow>
            <Grow in={checked} unmountOnExit={true} {...(checked ? { timeout: 500 } : {})}>
              <div>
                <Button variant="contained" size="large" color="primary" className={classNames(classes.subBtn)}
                  onClick={this.handleContactSupport}>
                  Get Support
                  <ChatBubbleOutlineOutlinedIcon className={classes.rightIcon} style={{marginRight: -5}} />
                </Button>
              </div>
            </Grow>
          </div>

          <Fab color={checked ? 'default' : 'secondary'} aria-label="small" className={classes.toggleBtn} >
            <HelpOutlineRoundedIcon fontSize="large" />
          </Fab>
        </div>
      </Root>
    );
  }
}

GetSupport.propTypes = {
};

export default GetSupport;
